import app from "@/main";

export const useStore = () => {
  return app.$store;
};
